import clip from "@/api/clip";

const state = {
    clips: []
};

const getters = {
    clips: state => {
        return state.clips;
    },
    currentPaginateClips: state => {
        return state.clips.data;
    }
};

const actions = {
    get({ commit }, params = null) {
        return clip
            .get(params)
            .then(response => {
                if (response.status === 200) {
                    commit("SET_CLIPS", response.data.data);
                }
                return response;
            })
            .catch(error => {
                console.log("error " + error);
                return error;
            });
    }
};

const mutations = {
    SET_CLIPS(state, value) {
        state.clips = value;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
